module.exports = __webpack_public_path__ + "img/member_register_bg.4ac5d35c.png";